// extracted by mini-css-extract-plugin
export var readonly = "_ik-1";
export var star = "_ik-0";